// removed by extract-text-webpack-plugin
module.exports = {"happyCustomersWrap":"qempo_HappyCustomers_happyCustomersWrap-1uVuX7z","titleWrap":"qempo_HappyCustomers_titleWrap-3ZnyzWL","happyCustomersContent":"qempo_HappyCustomers_happyCustomersContent-1Ujk0aV","column":"qempo_HappyCustomers_column-1GcNdT8","messageWrap":"qempo_HappyCustomers_messageWrap-L-BNZ-H","avatarWrap":"qempo_HappyCustomers_avatarWrap-3SVVa0d","imageWrap":"qempo_HappyCustomers_imageWrap-12YR_Gn","customerWrap":"qempo_HappyCustomers_customerWrap-1jA8Zp6","dots":"qempo_HappyCustomers_dots-eistTHS"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/home/elements/HappyCustomers/HappyCustomers.scss
// module id = 2242
// module chunks = 0